import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { catchError, Observable, throwError, switchMap } from 'rxjs';

/**
 * Intercept
 *
 * @param req
 * @param next
 */
export const authInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> =>
{
    const authService = inject(AuthService);

    // Clone the request object
    let newReq = req.clone();

    // if access token is expired, try to refresh it
    if ( authService.accessToken && !AuthUtils.isTokenExpired(authService.accessToken) )
    {
        newReq = req.clone({
            headers: req.headers.set('Authorization', 'Bearer ' + authService.accessToken),
        });
    }
    
    return next(newReq).pipe(
        catchError((error) =>
        {
            // Catch "401 Unauthorized" responses
            if ( error instanceof HttpErrorResponse && error.status === 401 && !req.url.includes("auth/refresh"))
            {
                if (authService.refreshToken)
                {
                    authService.updateTokenSync().then();
                    const retryReq = req.clone({
                        headers: req.headers.set('Authorization', 'Bearer ' + authService.accessToken),
                    });
                    return next(retryReq);
                }
                else
                {
                    authService.signOut();
                    location.reload();
                }
            }

            return throwError(error);
        }),
    );
};
